import { useQueryStates, parseAsIndex, parseAsInteger } from 'nuqs'

export const useVndlyWorkOrderIssuesPaginationQueryState = () => {
  const queryStates = useQueryStates(
    {
      pageIndex: parseAsIndex.withDefault(0),
      pageSize: parseAsInteger.withDefault(50),
    },
    {
      urlKeys: {
        pageIndex: 'work-order-page',
        pageSize: 'work-order-page-size',
      },
    }
  )

  return queryStates
}
